import {NgModule} from '@angular/core';
import {ProductSolrImageDirective} from './product-image';

@NgModule({
    declarations: [ProductSolrImageDirective],
    exports: [ProductSolrImageDirective]
})
/**
 * @deprecated Use `ProductSolrImageDirectiveModuleGeneric` from ngx-generic instead.
 */
export class ProductSolrImageDirectiveModule {}
